import { ReactElement } from "react";

export const Finished = (): ReactElement => {
  return (
    <div className={'rules rel'}>
      <div className={'pb_finished bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Упс, разлился резервуар с выгодой! Чиним. Не переживай, промокод придет к тебе на почту в течение пары дней!</h1>
        <div className={'rules__gears'}/>
      </div>
      <div className={'auth__machine-wrap'}>
        <div className={'auth__machine'}></div>
      </div>
    </div>
  )
}